import React, { useEffect, useState } from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import {
  CustomBadge,
  CustomButton,
  CustomCard,
} from "../../../../../../../../Components";
import {
  useSelectedTheme,
  useTranslate,
} from "../../../../../../../../Hooks";

// styles
import useStyles from "./styles";

// icons
import { UnitSizeIcon } from "../../../../../../../../assets/icons";

function PropertySpecificationComponent({ setTabValue , propertypeScificationData }) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { translate } = useTranslate("NewPropertiesView");
  const [mapArrayFiled, setMapArrayFiled] = useState([]);


  const mapFiled = () => {
    setMapArrayFiled([
      {
        title: translate("Apartment"),
        minValue: propertypeScificationData?.minApartmentArea || 0,
        maxValue: propertypeScificationData?.maxApartmentArea || 0,
        number: propertypeScificationData?.numberOfApartment || 0,
        area: 0,
      },
      {
        title: translate("Villa"),
        minValue: propertypeScificationData?.minVillaArea || 0,
        maxValue: propertypeScificationData?.maxVillaArea || 0,
        number: propertypeScificationData?.numberOfApartment || 0,
        area: 0,
      },
      {
        title: translate("Retail-Unit"),
        minValue: propertypeScificationData?.minRetailUnitArea || 0,
        maxValue: propertypeScificationData?.maxRetailUnitArea || 0,
        number: propertypeScificationData?.numberOfRetail || 0,
        area: propertypeScificationData?.retailUnitGrossArea || 0,
      },
      {
        title: translate("Office"),
        minValue: propertypeScificationData?.minOfficeArea || 0,
        maxValue: propertypeScificationData?.maxOfficeArea || 0,
        number: propertypeScificationData?.numberOfOffices || 0,
        area: propertypeScificationData?.officeGrossArea || 0,
      },
      {
        title: translate("Labor-Camp"),
        minValue: propertypeScificationData?.minLaborCampArea || 0,
        maxValue: propertypeScificationData?.maxLaborCampArea || 0,
        number: 0,
        area: propertypeScificationData?.laborCampGrossArea || 0,
      },
      {
        title: translate("Warehouse"),
        minValue: propertypeScificationData?.minWareHouseArea || 0,
        maxValue: propertypeScificationData?.maxWareHouseArea || 0,
        number: propertypeScificationData?.wareHouseGrossArea || 0,
        area: 0,
      },
      {
        title: translate("Studio"),
        minValue: propertypeScificationData?.minStudioArea || 0,
        maxValue: propertypeScificationData?.maxStudioArea || 0,
        number: propertypeScificationData?.numberOfStudio || 0,
        area: 0,
      },
      {
        title: translate("Townhouse"),
        minValue: propertypeScificationData?.minTownHouseArea || 0,
        maxValue: propertypeScificationData?.maxTownHouseArea || 0,
        number: propertypeScificationData?.numberOfTownHouse || 0,
        area: 0,
      },
      {
        title: translate("Penthouse"),
        minValue: propertypeScificationData?.minPentHouseArea || 0,
        maxValue: propertypeScificationData?.maxPentHouseArea || 0,
        number: propertypeScificationData?.numberOfPentHouse || 0,
        area: 0,
      },
    ]);
  };
  useEffect(() => {
    mapFiled();
  }, [propertypeScificationData]);

  return (
    <CustomCard
      borderRadius="xl"
      boxShadow="xs"
      borderColor="secondary"
      classes={styles.wapperPropretySpecification}
    >
      <Box>
        <Box className={styles.containerHeader}>
          <Typography className={styles.mainTitle}>
            {translate("Property-specification")}
          </Typography>
          <CustomButton
            boxShadow="none"
            size="md"
            onClick={() => {
              setTabValue(5);
            }}
            variant="text"
            color="tertiaryGray"
          >
            {translate("View-all")}
          </CustomButton>
        </Box>
        <Divider className={styles.divider} />
      </Box>
      <Box className={styles.containerBodyCard}>
        {mapArrayFiled &&
          mapArrayFiled?.map((item, index) => (
            <Box className={styles.rowItem} key={index}>
              <Box className={styles.containerTopSection}>
                <Typography className={styles.titleStyle}>
                  {item?.title}
                </Typography>
                <CustomBadge
                  label={`No .${item?.number}`}
                  SizeVariant={"small"}
                  BackgroundColor={palette.utility["brand_50"]}
                  BorderColor={palette.utility["brand_200"]}
                  Color={palette.utility["brand_700"]}
                />
              </Box>
              <Box className={styles.containerBottomSection}>
                <UnitSizeIcon
                  width="20"
                  height="20"
                  fill={palette.utility.utility_gray_700}
                />
                <Typography className={styles.valueStyle}>
                  {`${item?.area} ft ${item?.minValue} - ${item?.maxValue} sq.ft`}
                </Typography>
              </Box>
            </Box>
          ))}
      </Box>
    </CustomCard>
  );
}
export default PropertySpecificationComponent;
